/* "Shop all in this color" -> GA4 (Shopify.analytics.publish -> Web Pixel).
 * Click arms a 30-min window in localStorage; every /cart/add.js inside it gets
 * hidden `_sac_*` line-item properties so the order carries the source into
 * checkout. Only pages inside the funnel tag adds - see computeInFunnel(). Both
 * fetch (Quick Shop) and XHR (app.js $.ajax) are wrapped because the theme adds
 * to cart through both. */
(function () {
  'use strict';
  if (window.__shopAllColorAnalytics) return;
  window.__shopAllColorAnalytics = true;

  const SOURCE = 'shop_all_color';
  const STATE_KEY = '_sacAttribution';
  const CRUMB_KEY = '_sacPage';
  const WINDOW_MS = 30 * 60 * 1000; // keep in sync with the pixel
  const PROP_SOURCE = '_sac_source';
  const PROP_COLOR = '_sac_color';
  const PROP_CODE = '_sac_code';
  const CART_ADD = /\/cart\/add(\.js)?($|\?)/;

  const TRACK_ALL = (function () {
    try {
      const el = document.currentScript || document.querySelector('script[src*="shop-all-color-analytics"]');
      return !!el && el.getAttribute('data-track-all-colors') === 'true';
    } catch (e) { return false; }
  })();

  const publish = (name, payload) => {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload || {});
      }
    } catch (e) {}
  };

  const currency = () => {
    try { return (window.Shopify && Shopify.currency && Shopify.currency.active) || ''; } catch (e) { return ''; }
  };

  function readState() {
    try {
      const s = JSON.parse(localStorage.getItem(STATE_KEY) || 'null');
      if (!s || s.src !== SOURCE || !s.t) return null;
      return (Date.now() - s.t) < WINDOW_MS ? s : null;
    } catch (e) { return null; }
  }

  function writeState(s) {
    try { localStorage.setItem(STATE_KEY, JSON.stringify(s)); } catch (e) {}
    return s;
  }

  function armState(color, code) {
    const prev = readState();
    let name = (color || '').trim();
    if (!name && prev && prev.code === code) name = prev.color || '';
    return writeState({ src: SOURCE, color: name, code: code || '', t: Date.now() });
  }

  function touchState(state) {
    if (state) writeState({ src: SOURCE, color: state.color || '', code: state.code || '', t: Date.now() });
  }

  // Tells the pixel whether the page in front of the shopper is still in the funnel.
  function markFunnelState() {
    const s = readState();
    if (!s) return;
    const wasOut = s.out ? 1 : 0;
    const isOut = IN_FUNNEL ? 0 : 1;
    if (wasOut === isOut) return;
    if (isOut) s.out = 1; else delete s.out;
    writeState(s);
  }

  function readCrumb() {
    try {
      const c = JSON.parse(localStorage.getItem(CRUMB_KEY) || 'null');
      if (!c || !c.p || !c.t) return null;
      return (Date.now() - c.t) < WINDOW_MS ? c : null;
    } catch (e) { return null; }
  }

  function writeCrumb(inFunnel) {
    try {
      localStorage.setItem(CRUMB_KEY, JSON.stringify({ p: window.location.pathname || '', f: inFunnel ? 1 : 0, t: Date.now() }));
    } catch (e) {}
  }

  function colorsMap() {
    try {
      const el = document.querySelector('[data-colors-list]');
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) { return null; }
  }

  function colorNameFromCode(code) {
    if (!code) return '';
    const map = colorsMap();
    const hit = map && map[String(code).toUpperCase()];
    return hit ? String(hit).trim() : '';
  }

  // The colour option value is the code, so the option present in the map is it.
  function colorFromResponse(added) {
    const map = colorsMap();
    if (!map) return null;
    const opts = Array.isArray(added.variant_options) ? added.variant_options : (Array.isArray(added.options) ? added.options : []);
    for (const o of opts) {
      const code = String(o == null ? '' : o).trim().toUpperCase();
      if (code && map[code]) return { code: code, color: String(map[code]).trim() };
    }
    return null;
  }

  // `search_by=color` can be dropped by facet links, so the q signature counts too.
  function colorCodeFromQuery(params) {
    try {
      const q = params.get('q') || '';
      if (params.get('search_by') !== 'color' && !/variants\.(sku|title):/i.test(q)) return '';
      return (q.split(':').pop() || '').replace(/\*/g, '').trim();
    } catch (e) { return ''; }
  }

  function codeFromColorSearchUrl() {
    try { return colorCodeFromQuery(new URLSearchParams(window.location.search)); } catch (e) { return ''; }
  }

  function pageRole() {
    const path = (window.location.pathname || '');
    if (codeFromColorSearchUrl()) return 'search';
    if (path.indexOf('/products/') !== -1) return 'product';
    if (path.indexOf('/cart') !== -1 || path.indexOf('/checkout') !== -1) return 'neutral';
    return 'other';
  }

  function referrerInfo() {
    try {
      if (!document.referrer) return null;
      const u = new URL(document.referrer, window.location.href);
      if (u.origin !== window.location.origin) return { external: true };
      return { path: u.pathname || '', colorSearch: !!colorCodeFromQuery(u.searchParams) };
    } catch (e) { return null; }
  }

  // A page belongs to the funnel when it IS the colour results or was opened from
  // a page that belonged to it. The window itself is never deleted, so stepping
  // out to the homepage and coming back (Back button included) resumes tracking.
  function computeInFunnel(role) {
    if (role === 'search') return true;
    if (role === 'other') return false;
    const ref = referrerInfo();
    const crumb = readCrumb();
    if (!ref) return !!(crumb && crumb.f); // referrer stripped: trust the last page
    if (ref.external) return false;
    if (ref.colorSearch) return true;
    if (crumb && crumb.p === ref.path) return !!crumb.f;
    return false;
  }

  const ROLE = pageRole();
  const IN_FUNNEL = computeInFunnel(ROLE);

  function autoAddIds() {
    const ids = [];
    try {
      const v = window.liquidVars || {};
      [v.oneTreeProdID, v.productGiftWomen, v.productGiftMen].forEach((x) => {
        const n = parseInt(x, 10);
        if (n) ids.push(String(n));
      });
    } catch (e) {}
    return ids;
  }

  const isAutoAdd = (id) => !!id && autoAddIds().indexOf(String(id)) !== -1;

  const upsellOwnsAdd = () => {
    try { return typeof window.__cartUpsellPending === 'function' && !!window.__cartUpsellPending(); } catch (e) { return false; }
  };

  function inspectBody(body) {
    if (!body) return null;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      let id = '';
      try { id = body.get('id') != null ? String(body.get('id')) : ''; } catch (e) {}
      return id ? { kind: 'form', id: id, fd: body } : null;
    }
    if (typeof body !== 'string') return null;
    const trimmed = body.replace(/^\s+/, '');
    if (trimmed.charAt(0) === '{') {
      let obj;
      try { obj = JSON.parse(trimmed); } catch (e) { return null; }
      if (!obj || typeof obj !== 'object' || Array.isArray(obj.items)) return null;
      const id = obj.id != null ? String(obj.id) : '';
      return id ? { kind: 'json', id: id, obj: obj } : null;
    }
    if (body.indexOf('=') === -1) return null;
    let sp;
    try { sp = new URLSearchParams(body); } catch (e) { return null; }
    const id = sp.get('id') || '';
    return id ? { kind: 'query', id: id, sp: sp } : null;
  }

  function hasProp(info, name) {
    const key = 'properties[' + name + ']';
    try {
      if (info.kind === 'json') return !!(info.obj.properties && name in info.obj.properties);
      if (info.kind === 'query') return info.sp.has(key);
      return info.fd.get(key) != null;
    } catch (e) { return false; }
  }

  function applyProps(info, props) {
    if (info.kind === 'json') {
      info.obj.properties = info.obj.properties || {};
      for (const k in props) { if (!(k in info.obj.properties)) info.obj.properties[k] = props[k]; }
      return JSON.stringify(info.obj);
    }
    if (info.kind === 'query') {
      for (const k in props) {
        const key = 'properties[' + k + ']';
        if (!info.sp.has(key)) info.sp.append(key, props[k]);
      }
      return info.sp.toString();
    }
    for (const k in props) {
      const key = 'properties[' + k + ']';
      if (info.fd.get(key) == null) info.fd.append(key, props[k]);
    }
    return info.fd;
  }

  function propsFor(state, pickedCode) {
    const props = {};
    props[PROP_SOURCE] = SOURCE;
    if (TRACK_ALL) {
      // No _sac_code, so the pixel counts the line whatever colour was bought.
      const shown = colorNameFromCode(pickedCode) || state.color || pickedCode || state.code || '';
      if (shown) props[PROP_COLOR] = shown;
      return props;
    }
    if (state.code) props[PROP_CODE] = state.code;
    if (state.color) props[PROP_COLOR] = state.color;
    return props;
  }

  // Colour selected in whichever UI is in front: Quick Shop popup, else the PDP
  // link, whose href always mirrors the selected colour.
  function currentColorCode() {
    try {
      const popup = document.getElementById('quick-add-popup');
      if (popup && popup.classList.contains('_is-visible')) {
        const sw = popup.querySelector('.option-color.active[data-val]:not([style*="display: none"])') || popup.querySelector('.option-color.active[data-val]');
        return sw ? (sw.getAttribute('data-val') || '').trim().toUpperCase() : '';
      }
      const link = document.querySelector('[data-color-search-link]');
      if (!link || !link.getAttribute('href')) return '';
      const q = new URL(link.href, window.location.origin).searchParams.get('q') || '';
      return (q.split(':').pop() || '').replace(/\*/g, '').trim().toUpperCase();
    } catch (e) { return ''; }
  }

  function addedColorMatches(added, code) {
    if (!code) return true;
    const CODE = String(code).toUpperCase();
    const opts = Array.isArray(added.variant_options) ? added.variant_options
               : (Array.isArray(added.options) ? added.options : []);
    if (opts.length) {
      for (const o of opts) { if (String(o).toUpperCase() === CODE) return true; }
      return false;
    }
    const sku = String(added.sku || '').toUpperCase();
    if (sku) return sku.indexOf(CODE) !== -1;
    return true; // unverifiable: keep the event rather than drop it
  }

  function tagAdd(body, state) {
    if (!IN_FUNNEL) return null;
    const info = inspectBody(body);
    if (!info) return null;
    if (isAutoAdd(info.id)) return null;
    if (hasProp(info, '_cart_upsell_discount')) return null;
    const picked = currentColorCode();
    if (!TRACK_ALL && picked && state.code && picked !== String(state.code).toUpperCase()) return null;
    return applyProps(info, propsFor(state, picked));
  }

  function publishAdd(data, state) {
    const added = data && data.items ? data.items[0] : data;
    if (!added) return;
    let color = state.color || '';
    let code = state.code || '';
    if (TRACK_ALL) {
      const actual = colorFromResponse(added);
      if (actual) { color = actual.color; code = actual.code; }
    } else if (!addedColorMatches(added, state.code)) {
      return;
    }
    const cents = typeof added.final_price === 'number' ? added.final_price
                : (typeof added.price === 'number' ? added.price : 0);
    const price = cents / 100;
    const qty = added.quantity || 1;
    publish('liveclothing:sac_add_to_cart', {
      color: color,
      color_code: code,
      currency: currency(),
      value: Math.round(price * qty * 100) / 100,
      items: [{
        item_id: String(added.variant_id || added.id || ''),
        item_name: added.product_title || added.title || '',
        item_variant: added.variant_title || '',
        price: price,
        quantity: qty
      }]
    });
  }

  function patchFetch() {
    if (!window.fetch || window.__sacFetchPatched) return;
    window.__sacFetchPatched = true;
    const _fetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      try {
        const url = (typeof input === 'string') ? input : (input && input.url) || '';
        const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && CART_ADD.test(url) && !upsellOwnsAdd() && init && init.body) {
          const state = readState();
          if (state) {
            const newBody = tagAdd(init.body, state);
            if (newBody != null) {
              const ni = {};
              for (const k in init) ni[k] = init[k];
              ni.body = newBody;
              touchState(state);
              const resp = _fetch(input, ni);
              resp.then((r) => {
                try {
                  if (!r.ok) return;
                  r.clone().json().then((d) => publishAdd(d, state)).catch(() => {});
                } catch (e) {}
              }).catch(() => {});
              return resp;
            }
          }
        }
      } catch (e) {}
      return _fetch(input, init);
    };
  }

  function patchXHR() {
    if (!window.XMLHttpRequest || window.__sacXhrPatched) return;
    window.__sacXhrPatched = true;
    const proto = window.XMLHttpRequest.prototype;
    const _open = proto.open;
    const _send = proto.send;

    proto.open = function (method, url) {
      try {
        this.__sacMethod = String(method || '').toUpperCase();
        this.__sacUrl = String(url || '');
      } catch (e) {}
      return _open.apply(this, arguments);
    };

    proto.send = function (body) {
      let out = body;
      try {
        if (this.__sacMethod === 'POST' && CART_ADD.test(this.__sacUrl || '') && !upsellOwnsAdd() && body) {
          const state = readState();
          if (state) {
            const newBody = tagAdd(body, state);
            if (newBody != null) {
              out = newBody;
              touchState(state);
              const xhr = this;
              xhr.addEventListener('load', function () {
                try {
                  if (xhr.status < 200 || xhr.status >= 300) return;
                  publishAdd(JSON.parse(xhr.responseText), state);
                } catch (e) {}
              });
            }
          }
        }
      } catch (e) { out = body; }
      return _send.call(this, out);
    };
  }

  patchFetch();
  patchXHR();

  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('.color-search-link, [data-color-search-link]');
    if (!link) return;

    let code = '';
    try {
      const q = new URL(link.href, window.location.origin).searchParams.get('q') || '';
      code = q.split(':').pop() || '';
    } catch (err) {}

    const nameEl = document.querySelector('.color-core .core-color-title');
    const color = nameEl ? (nameEl.textContent || '').trim() : '';
    const variants = link.closest('.product-variants');
    const handle = variants ? variants.getAttribute('data-handle') : '';
    const device = link.classList.contains('color-search-link--mobile') ? 'mobile' : 'desktop';

    armState(color, code);
    publish('shop_all_color_click', { color: color, color_code: code, item_handle: handle, device: device });
  });

  if (ROLE === 'search') {
    const urlCode = codeFromColorSearchUrl();
    armState(colorNameFromCode(urlCode), urlCode);
  }
  if (readState()) writeCrumb(IN_FUNNEL);
  markFunnelState();

  window.addEventListener('pageshow', markFunnelState);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) markFunnelState(); });
})();
